export default __webpack_public_path__ + "be9f02cadfc4d6a15b5ee14c6ca3ecc6.png";